import { FC } from "react";
import { Trans } from "react-i18next";
import { LogoFull } from "assets/svg";
import { useAppSelector } from "store/hooks";
import { userMetadataSelector } from "store/selectors";

import { getCompanyDefaultBankAccountBenefitsList } from "components/PayDistribution/constants";

import { IProps } from "./types";
import useCBACards from "./useCBACards";
import {
  Card1BenefitsList,
  Card1Icon,
  Card1ListTexWithIcon,
  CBACardFooter,
  CBACardMainContent,
  CBACFDisclaimer,
  CBACFPPSubitle,
  CBACFPPText,
  CBACFPPTitle,
  CBACFPromoPoint,
  CBACFPromoPointsContainer,
  CBCMATop,
  CBCMATopLogo,
  CBCMATopTitle,
  CompanyEmphasized,
  Container,
} from "./styles";

const CBACard1: FC<IProps> = (props) => {
  const { className } = props;

  const benefitsListTranslationPrefix = `components.pay_distribution.default_company_bank_account_benefits_banner.benefits`;
  const benefitsList = getCompanyDefaultBankAccountBenefitsList(`${benefitsListTranslationPrefix}`);
  const commonTranslationPrefix = `components.company_bank_account_promo_cards.shared`;
  const translationPrefix = `components.company_bank_account_promo_cards.card1`;

  const currentUser = useAppSelector(userMetadataSelector);

  const { baseConfig } = useCBACards(props);

  const renderLargeCompanyBankAccountCardContent = () => {
    return (
      <CBACardMainContent>
        <CBCMATop>
          <CBCMATopLogo>
            <LogoFull />
          </CBCMATopLogo>
          <CBCMATopTitle>
            <Trans i18nKey={`${commonTranslationPrefix}.title_common`} />
          </CBCMATopTitle>
        </CBCMATop>

        <Card1BenefitsList>
          {benefitsList.map((item) => {
            return (
              <Card1ListTexWithIcon key={item.index.toString()}>
                <Card1Icon>{item.icon}</Card1Icon>
                <Trans i18nKey={item.text} />
              </Card1ListTexWithIcon>
            );
          })}
        </Card1BenefitsList>
      </CBACardMainContent>
    );
  };

  const renderLargeCompanyBankAccountCardFooterContent = () => {
    return (
      <CBACardFooter>
        <CBACFPromoPointsContainer>
          <CBACFPromoPoint>
            <Trans
              i18nKey={`${commonTranslationPrefix}.promo_points.p1_alt`}
              components={{
                1: <CBACFPPTitle />,
                2: <CBACFPPSubitle />,
                3: <CBACFPPText />,
              }}
            />
          </CBACFPromoPoint>

          <CBACFPromoPoint>
            <Trans
              i18nKey={`${commonTranslationPrefix}.promo_points.p2`}
              components={{
                1: <CBACFPPTitle />,
                2: <CBACFPPSubitle />,
                3: <CBACFPPText />,
              }}
            />
          </CBACFPromoPoint>

          <CBACFPromoPoint>
            <Trans
              i18nKey={`${commonTranslationPrefix}.promo_points.p3_alt`}
              components={{
                1: <CBACFPPTitle />,
                2: <CBACFPPSubitle />,
                3: <CBACFPPText />,
              }}
            />
          </CBACFPromoPoint>
        </CBACFPromoPointsContainer>
        <CBACFDisclaimer>
          <Trans i18nKey={`${translationPrefix}.disclaimer`} />
        </CBACFDisclaimer>
      </CBACardFooter>
    );
  };

  const cardConfig = {
    title: (
      <Trans
        i18nKey={`${translationPrefix}.title`}
        components={{
          1: <CompanyEmphasized />,
        }}
      />
    ),
    description: (
      <Trans
        i18nKey={`${translationPrefix}.description`}
        components={{
          1: <CompanyEmphasized />,
        }}
      />
    ),
    largeContent: renderLargeCompanyBankAccountCardContent(),
    largeFooterContent: renderLargeCompanyBankAccountCardFooterContent(),
  };

  const config: IProps = {
    ...baseConfig,
    ...cardConfig,
    ...props,
  };

  return <Container className={`card_1 ${className}`} {...config} />;
};

export default CBACard1;
